import { Box } from "@vinomofo/components";
import visa from "./logos/visa.svg";
import mastercard from "./logos/mastercard.svg";
import americanExpress from "./logos/americanexpress.svg";
import paypal from "./logos/paypal.svg";
import afterpay from "./logos/afterpay.svg";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";

const StyledWrapper = styled(Box)`
  img {
    width: 50px;

    & + img {
      margin-left: 10px;
    }
  }
`;

type PaymentMethodsT = {
  code: string;
  name: string;
};

type PaymentMethodsTParans = {
  node: PaymentMethodsT;
};

const transformBCPaymentMethods = (
  paymentMethods: Array<PaymentMethodsTParans>
): Array<PaymentMethodsT> => {
  return paymentMethods.map((data) => ({
    code: data.node.code,
    name: data.node.name,
  }));
};

// Use to map gateway code to Bigcommerce payment method
const paymentOptionCards = [
  { svg: visa, gateway: "stripev3" },
  { svg: visa, gateway: "stripeupe" },
  { svg: mastercard, gateway: "stripev3" },
  { svg: mastercard, gateway: "stripeupe" },
  { svg: americanExpress, gateway: "stripev3" },
  { svg: americanExpress, gateway: "stripeupe" },
  { svg: paypal, gateway: "paypalexpress" },
  { svg: paypal, gateway: "paypalcommerce" },
  { svg: afterpay, gateway: "afterpay" },
];

export const PaymentOptionLogos = (): JSX.Element => {
  const { allPaymentMethods } = useStaticQuery(graphql`
    {
      allPaymentMethods {
        edges {
          node {
            code
            name
          }
        }
        totalCount
      }
    }
  `);

  const transformedBCPaymentMethods = transformBCPaymentMethods(
    allPaymentMethods.edges
  );

  return (
    <StyledWrapper width="100%" display="flex" justifyContent="flex-start">
      {paymentOptionCards.map((option, index) => {
        return (
          transformedBCPaymentMethods.find(
            (pm) => pm.code === option.gateway
          ) && <img key={index} src={option.svg} alt={option.gateway} />
        );
      })}
    </StyledWrapper>
  );
};
